export default __webpack_public_path__ + "static/media/6.1078cfa4.jpg";